import React from 'react'
import Ex from '../Cards/Ex'
import ProductCard from '../Cards/ProductCard';
import Collections from '../../Data/Collections';
const Topdeals = () => {
  return (
    <div className='w-full lg:px-8 px-2 py-2 lg:py-4'>
        <h1 className='text-2xl md:text-3xl  font-bold py-2 lg:ml-4 mb-4'>Top Deals</h1>
        <div className='grid grid-cols-2 lg:grid-cols-5 md:grid-cols-4 gap-3'>
          {
            Collections.Grocceries.map((curElem,index)=>{
              return (
                <div key={index}>
                <ProductCard  ProductDetails={curElem} />
              </div>
              )
          
              
            })
          }
       
       
        </div>

    </div>
  
  )
}

export default Topdeals